import { isString, startsWith } from 'lodash-es'
import { forwardRef } from 'react'
import type { LinkProps as RouterLinkProps } from 'react-router-dom'
import { Link as RouterLink } from 'react-router-dom'

import type { LinkProps as MuiLinkProps } from '@mui/material/Link'

export type LinkBehaviorProps = Omit<RouterLinkProps, 'to'> & {
  href: string
} & Omit<MuiLinkProps, 'href'>

/**
 * MUI Link に React Router DOM の機能を持たせるビヘイビア
 */
export const LinkBehavior = forwardRef<HTMLAnchorElement, LinkBehaviorProps>((props, ref) => {
  const { href, ...other } = props

  const isExternal =
    isString(href) && ((startsWith(href, 'http') && !/localhost/.test(href)) || startsWith(href, 'mailto:'))

  if (isExternal) {
    return <a ref={ref} href={href} target="_blank" rel="noopener noreferrer" {...other} />
  }

  return <RouterLink ref={ref} to={href} {...other} />
})
